import AddToProjectModal from 'components/common/Search/AddToProjectModal/AddToProjectModal';
import { RequestContext, RequestTypes } from 'types/ContactRequests';
import { ProductType } from 'types/Products';
import { LogEventType } from 'types/LogEvents';
import { formatSearchLog } from 'helpers/utilsTS';
import { useLogEvent } from 'api/services/LogEventService';
import { Asset } from 'types/Asset';
import { SearchDocument, SearchRequest } from 'types/Search';
import { lazy } from 'react';
import { SegmentTag } from 'types/global';
import { AddToCartDialog } from 'components/common/Requests/AddToCartDialog';
const RequestContactDialog = lazy(
  () => import('components/common/Requests/RequestContactDialog')
);
const RequestDocumentDialog = lazy(
  () => import('components/common/Requests/RequestDocumentDialog')
);
const RequestQuoteOrSampleDialog = lazy(
  () => import('components/common/Requests/RequestQuoteOrSampleDialog')
);

export enum ActionsModalType {
  DOCUMENT_REQUEST = 'documentRequest',
  QUOTE = 'quote',
  SAMPLE = 'sample',
  CONTACT = 'contact',
  PROJECT = 'project',
  CART_SAMPLE = 'CART_SAMPLE'
}

export const ProductActionModals: React.FC<{
  modalType: ActionsModalType;
  productType: ProductType;
  logEventsData: {
    products: any[];
    searchRequest?: any;
  };
  onClose: () => void;
  documents?: Asset[] | undefined;
  context: RequestContext;
}> = ({
  modalType,
  productType,
  logEventsData,
  onClose,
  documents,
  context
}) => {
  switch (modalType) {
    case ActionsModalType.DOCUMENT_REQUEST:
      return (
        <RequestDocumentDialog
          productType={productType}
          show={true}
          fullProducts={logEventsData.products}
          searchContext={logEventsData.searchRequest !== undefined}
          context={context}
          requestType={RequestTypes.DOCUMENT}
          setModal={onClose}
          documents={documents}
          // searchRequest={logEventsData}
        />
      );
    case ActionsModalType.SAMPLE:
      return (
        <RequestQuoteOrSampleDialog
          productType={productType}
          show={true}
          context={context}
          requestType={RequestTypes.SAMPLE}
          setModal={onClose}
          fullProducts={logEventsData.products}
          searchContext={logEventsData.searchRequest !== undefined}
        />
      );
    case ActionsModalType.QUOTE:
      return (
        <RequestQuoteOrSampleDialog
          productType={productType}
          show={true}
          context={context}
          requestType={RequestTypes.QUOTE}
          setModal={onClose}
          fullProducts={logEventsData.products}
          searchContext={logEventsData.searchRequest !== undefined}
        />
      );
    case ActionsModalType.CONTACT:
      return (
        <RequestContactDialog
          show={true}
          setModal={onClose}
          context={context}
          requestType={RequestTypes.CONTACT}
          fullProducts={logEventsData.products}
          searchContext={logEventsData.searchRequest !== undefined}
          productType={productType}
        />
      );
    case ActionsModalType.PROJECT:
      return (
        <AddToProjectModal
          product={logEventsData.products[0]}
          setShow={onClose}
          show={true}
        />
      );
    case ActionsModalType.CART_SAMPLE:
      return (
        <AddToCartDialog
          open={modalType === ActionsModalType.CART_SAMPLE}
          onClose={() => onClose()}
          products={logEventsData.products}
        />
      );
  }
};

export const useSaveClickEvent = () => {
  const logEvent = useLogEvent();

  const saveClickEvent = (
    logEventsData: {
      products: SearchDocument[];
      searchRequest?: SearchRequest;
    },
    eventLog: LogEventType,
    segment?: SegmentTag,
    eventKey?: string
  ) => {
    const LogProductsFormat = logEventsData?.products?.map((pro: any) => ({
      document: pro
    }));

    const data = formatSearchLog(
      {
        results: LogProductsFormat,
        search: logEventsData?.searchRequest ?? { query: '' }
      },
      logEventsData?.searchRequest?.filters ?? [],
      segment ?? SegmentTag.PERSONALCARE
    );
    logEvent(data, eventLog, eventKey);
  };
  return saveClickEvent;
};
